// b2c列表
export default [
    {
        path: "b2corder",
        name: "b2cOrder",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/list/index"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "giftb2corder",
        name: "giftb2cOrder",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/list/index"),
        // meta: {
        //     bread: false,
        // }
    },
    // b2c订单编辑查看
    {
        path: "b2corder/upadte/:type",
        name: "b2cOrderupdate",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/update/index"),
        meta: {
            bread: false,
        }
    },
    // 添加礼品单
    {
        path: "b2corder/addgistlist/:type",
        name: "addgiftlist",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/giftlist/addgiftlist"),
        meta: {
            bread: false,
        }
    },
    {
        path: "unshippedOrderList",
        name: "unshippedOrderList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/unshipped/index"),
        // meta: {
        //     bread: false,
        // }
    },
    // 订单拆分
    {
        path: "orderSplit",
        name: "orderSplit",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/ordersplit/index"),
        // meta: {
        //     bread: false,
        // }
    },
]